import { Form, Formik } from 'formik';
import React from 'react';
import { Mutation } from 'react-apollo';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import CheckboxInput from '../../../components/CheckboxInput';
import FormField from '../../../components/FormField';
import TextInput, { Input } from '../../../components/TextInput';
import { ADMIN_CREATE_THYROID_PROGRAMS, ADMIN_GET_COURSE_PAYMENT_SCREEN, ADMIN_GET_THYROID_PROGRAMS, ADMIN_UPSERT_COURSE_PAYMENT_SCREEN } from '../../../graphql';
import styled from 'styled-components';
import { useState } from 'react';
import TextArea from '../../../components/TextArea';

const ModalInner = styled(Box)`
  max-width: 80vw;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
`;

const Expandable = ({ data }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Flex flexDirection={'column'} style={{ width: '100%' }} mb={4}>
      <Text
        flex={1}
        color={'white'}
        style={{ cursor: 'pointer' }}
        onClick={() => {
          setIsExpanded(!isExpanded);
        }}
      >
        {data.title}
      </Text>
      {isExpanded && <Text style={{ fontSize: 12, color: 'white', marginTop: 8 }}>{data.text}</Text>}
    </Flex>
  );
};

const Image = ({ data, index }) => {
  console.log({ data });
  return (
    <Flex flexDirection={'column'} style={{ width: '175px' }} mr={3}>
      <Flex style={{ flexDirection: 'row', marginBottom: 12 }}>
        <Flex style={{ backgroundColor: '#DBE6F9', borderRadius: 10, alignItems: 'center', justifyContent: 'center', height: 23, width: 23 }}>
          <Text style={{ fontSize: 12 }}>{index}</Text>
        </Flex>
        <Flex style={{ flex: 1, height: 1, alignSelf: 'center', marginLeft: 8, background: 'linear-gradient(90deg, #DBE6F9 0%, rgba(219, 230, 249, 0.00) 100%)' }} />
      </Flex>
      <img src={data.url} />
      <Text style={{ color: 'white', fontSize: 14, fontWeight: 300, maxWidth: 160, marginTop: 12 }}>{data.subtext}</Text>
    </Flex>
  );
};

const EditPaymentScreen = ({ onSave, onClose, initialValues, courseId }) => {
  const [isLearnmoreExpanded, setIsLearnmoreExpanded] = useState(false);

  return (
    <Mutation
      mutation={ADMIN_UPSERT_COURSE_PAYMENT_SCREEN}
      refetchQueries={[{ query: ADMIN_GET_COURSE_PAYMENT_SCREEN, variables: { courseId: courseId } }]}
      awaitRefetchQueries={true}
      onCompleted={() => {
        onSave();
      }}
    >
      {(createPlan, { loading }) => (
        <Formik
          isInitialValid={
            ({ initialValues }) => true
            //   schema.isValidSync(initialValues)
          }
          initialValues={{
            ...initialValues,
            // bulletPointsList: ((initialValues || {}).bulletPointsList || []).split()
          }}
          // validationSchema={schema}
          onSubmit={async (values, actions) => {
            const lms = {
              images: [],
              sections: [],
            };
            if (values.learnMoreSection) {
              if (values.learnMoreSection.images) {
                for (let index = 0; index < (values.learnMoreSection.images || []).length; index++) {
                  const element = values.learnMoreSection.images[index];
                  lms.images.push({
                    url: element.url,
                    subtext: element.subtext,
                    order: element.order,
                  });
                }
              }
              if (values.learnMoreSection.sections) {
                for (let index = 0; index < (values.learnMoreSection.sections || []).length; index++) {
                  const element = values.learnMoreSection.sections[index];
                  lms.sections.push({
                    title: element.title,
                    text: element.text,
                    order: element.order,
                  });
                }
              }
            }
            let vars = {
              id: (initialValues || {}).id,
              courseId: courseId,
              title: values.title,
              bulletPointsList: values.bulletPointsList,
              disclaimer: values.disclaimer,
              subPriceText: values.subPriceText,
              learnMoreSection: lms,
            };
            
            await createPlan({
              variables: {
                data: { ...vars },
              },
            });

            // if (onClose) {
            //   onClose();
            // }
            actions.setSubmitting(false);
          }}
          render={({ touched, errors, isValid, handleChange, handleBlur, isSubmitting, setFieldValue, setFieldTouched, values, submitForm }) => (
            <Flex flex={1}>
              <Flex flexDirection={'column'} flex={1} style={{ overflow: 'auto' }}>
                <Form>
                  <Flex flexDirection="column" width="400px" style={{ maxHeight: '900px' }}>
                    <FormField mb={4} error={touched.title && errors.title}>
                      <label for="title">Title</label>
                      <TextInput name="title" placeholder="Title" />
                    </FormField>

                    <FormField mb={4} error={touched.subPriceText && errors.subPriceText}>
                      <label for="subPriceText">Sub Price Text</label>
                      <TextInput name="subPriceText" placeholder="Sub Price Text" />
                    </FormField>

                    <FormField mb={4} error={touched.bulletPointsList && errors.bulletPointsList}>
                      <label for="bulletPointsList">Bullet Points List</label>
                      {(values.bulletPointsList || []).map((x, i) => {
                        return (
                          <Flex>
                            <TextArea
                              style={{ flex: 1 }}
                              key={`bpl_${i}`}
                              value={x}
                              onChange={(e) => {
                                const f = values.bulletPointsList || [];
                                f[i] = e.target.value;
                                setFieldValue('bulletPointsList', f);
                              }}
                            />

                            <div
                              title="delete"
                              style={{ cursor: 'pointer', marginLeft: '8px' }}
                              onClick={() => {
                                const f = values.bulletPointsList || [];
                                f.splice(i, 1);
                                setFieldValue('bulletPointsList', f);
                              }}
                            >
                              🗑
                            </div>
                          </Flex>
                        );
                      })}
                      <Button
                        variant={'primary'}
                        mt={3}
                        disabled={(values.bulletPointsList || []).filter((xx) => !xx).length > 0}
                        style={{ padding: '2px 8px', width: 'fit-content' }}
                        type="button"
                        onClick={() => {
                          const f = values.bulletPointsList || [];
                          f.push('');
                          setFieldValue('bulletPointsList', f);
                        }}
                      >
                        add
                      </Button>
                    </FormField>

                    <FormField mb={4} error={touched.disclaimer && errors.disclaimer}>
                      <label for="disclaimer">Disclaimer</label>
                      <TextInput name="disclaimer" placeholder="Disclaimer" />
                    </FormField>

                    <Text mb={3} fontWeight={500}>
                      Learn More Section:
                    </Text>
                    <FormField mb={4} error={touched.bgMainColor && errors.bgMainColor}>
                      <label for="bulletPointsList">Images</label>
                      {((values.learnMoreSection || {}).images || []).map((x, i) => {
                        return (
                          <Flex mb={3} key={`lmi_${i}_url`}>
                            <Box
                              style={{
                                backgroundColor: 'rgb(54, 79, 121)',
                                width: '4px',
                              }}
                              mr={3}
                            />
                            <Flex flexDirection={'column'} flex={1} mr={2}>
                              <Input
                                value={x.url}
                                placeholder="url"
                                style={{ padding: '6px 8px', width: '100%', marginBottom: '8px' }}
                                onChange={(e) => {
                                  const f = (values.learnMoreSection || {}).images || [];
                                  f[i].url = e.target.value;
                                  setFieldValue('learnMoreSection.images', f);
                                }}
                              />
                              <Input
                                key={`lms_${i}_subtext`}
                                value={x.subtext}
                                placeholder="text"
                                style={{ padding: '6px 8px', width: '100%' }}
                                onChange={(e) => {
                                  const f = (values.learnMoreSection || {}).images || [];
                                  f[i].subtext = e.target.value;
                                  setFieldValue('learnMoreSection.images', f);
                                }}
                              />
                            </Flex>
                            <div
                              title="delete"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                const f = (values.learnMoreSection || {}).images || [];
                                f.splice(i, 1);
                                setFieldValue('learnMoreSection.images', f);
                              }}
                            >
                              🗑
                            </div>
                          </Flex>
                        );
                      })}
                      <Button
                        variant={'primary'}
                        mt={1}
                        disabled={((values.learnMoreSection || {}).images || []).filter((xx) => !xx.url).length > 0}
                        style={{ padding: '2px 8px', width: 'fit-content' }}
                        type="button"
                        onClick={() => {
                          const f = (values.learnMoreSection || {}).images || [];
                          f.push({ url: '', subtext: '' });
                          setFieldValue('learnMoreSection.images', f);
                        }}
                      >
                        add
                      </Button>
                    </FormField>

                    <FormField mb={4} error={touched.bgMainColor && errors.bgMainColor}>
                      <label for="bulletPointsList">Expandable Texts</label>
                      {((values.learnMoreSection || {}).sections || []).map((x, i) => {
                        return (
                          <Flex mb={3} key={`lms_${i}_title`}>
                            <Box
                              style={{
                                backgroundColor: 'rgb(54, 79, 121)',
                                width: '4px',
                              }}
                              mr={3}
                            />
                            <Flex flexDirection={'column'} flex={1} mr={2}>
                              <Input
                                mb={2}
                                value={x.title}
                                style={{ padding: '6px 8px', width: '100%', marginBottom: '8px' }}
                                placeholder="title"
                                onChange={(e) => {
                                  const f = (values.learnMoreSection || {}).sections || [];
                                  f[i].title = e.target.value;
                                  setFieldValue('learnMoreSection.sections', f);
                                }}
                              />
                              <TextArea
                                key={`lms_${i}_text`}
                                value={x.text}
                                placeholder="text"
                                style={{ padding: '6px 8px', width: '100%' }}
                                onChange={(e) => {
                                  const f = (values.learnMoreSection || {}).sections || [];
                                  f[i].text = e.target.value;
                                  setFieldValue('learnMoreSection.sections', f);
                                }}
                              />
                            </Flex>
                            <div
                              title="delete"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                const f = (values.learnMoreSection || {}).sections || [];
                                f.splice(i, 1);
                                setFieldValue('learnMoreSection.sections', f);
                              }}
                            >
                              🗑
                            </div>
                          </Flex>
                        );
                      })}
                      <Button
                        variant={'primary'}
                        mt={1}
                        disabled={((values.learnMoreSection || {}).sections || []).filter((xx) => !xx.title).length > 0}
                        style={{ padding: '2px 8px', width: 'fit-content' }}
                        type="button"
                        onClick={() => {
                          const f = (values.learnMoreSection || {}).sections || [];
                          f.push({ title: '', text: '' });
                          setFieldValue('learnMoreSection.sections', f);
                        }}
                      >
                        add
                      </Button>
                    </FormField>

                    <Flex mt={4} flexDirection="row" alignItems="center" justifyContent="space-between">
                      <Button
                        style={{
                          background: 'white',
                          color: '#344f79',
                          border: '1px solid #344f79',
                        }}
                        type="button"
                        onClick={onClose}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="button"
                        disabled={!isValid || isSubmitting}
                        style={{ background: '#344f79' }}
                        onClick={() => {
                          submitForm();
                          // createCategory();
                        }}
                      >
                        Save
                      </Button>
                    </Flex>
                  </Flex>
                </Form>
              </Flex>
              <Flex>
                <Flex
                  flexDirection={'column'}
                  style={{
                    width: '350px',
                    overflow: 'hidden',
                    height: '800px',
                    backgroundColor: '#FDF5F2',
                    borderRadius: '36px',
                    border: '2px solid #344f79',
                    position: 'relative',
                    padding: '16px',
                    paddingTop: '60px',
                  }}
                >
                  <Heading textAlign={'center'} marginTop={'20px'} style={{ maxWidth: '75%', alignSelf: 'center' }}>
                    {values.title}
                  </Heading>
                  <Box style={{ backgroundColor: 'white', borderRadius: 12, padding: '8px 32px 16px', alignSelf: 'center', marginTop: 32 }}>
                    <Heading textAlign={'center'}>$149</Heading>
                    <Text fontSize={14} fontFamily="Poppins Light" style={{ textAlign: 'center', marginTop: 8 }}>
                      {values.subPriceText}
                    </Text>
                  </Box>

                  <Flex style={{ flexDirection: 'column', marginTop: 16, marginRight: 12 }}>
                    {(values.bulletPointsList || []).map((x, bi) => (
                      <Flex mt="16px" key={`blp_${bi}`}>
                        <Box style={{ width: 8, height: 8, backgroundColor: '#344f79', borderRadius: 4, marginRight: 12, marginTop: 6 }} />
                        <Text fontSize={'14px'}>{x}</Text>
                      </Flex>
                    ))}
                  </Flex>

                  <Button mt="32px" mb={4} variant={'primary'} style={{ alignSelf: 'center' }} type="button" onClick={() => {}}>
                    Purchase
                  </Button>
                  <Text fontSize={'10px'} style={{ textAlign: 'center', fontWeight: 300 }}>
                    {values.disclaimer}
                  </Text>

                  <Flex
                    flexDirection={'column'}
                    style={{
                      background: '#344f79',
                      borderRadius: '20px 20px 0 0',
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      height: isLearnmoreExpanded ? '90%' : '80px',
                      paddingLeft: '16px',
                      paddingRight: '16px',
                    }}
                  >
                    <Box
                      style={{ background: 'white', height: '2px', width: '45px', alignSelf: 'center', cursor: 'pointer' }}
                      mt="16px"
                      mb={3}
                      onClick={() => setIsLearnmoreExpanded(!isLearnmoreExpanded)}
                    />
                    <Text style={{ color: 'white', textAlign: 'center' }} mb={3}>
                      Learn More
                    </Text>

                    {!!isLearnmoreExpanded && (
                      <>
                        <Text mt={3} fontSize={18} fontFamily="Poppins Medium" style={{ textAlign: 'left', color: 'white', marginBottom: 12, marginLeft: 17 }}>
                          How it works
                        </Text>
                        <Flex mb={4} mt={2}>
                          {((values.learnMoreSection || {}).images || []).map((x, i) => {
                            return <Image key={`expSec_${i}`} data={x} index={i + 1} />;
                          })}
                        </Flex>
                        {((values.learnMoreSection || {}).sections || []).map((x, i) => {
                          return <Expandable key={`expSec_${i}`} data={x} />;
                        })}
                      </>
                    )}
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          )}
        />
      )}
    </Mutation>
  );
};

export default EditPaymentScreen;
